import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Row, Col, Button } from 'reactstrap';

import ComplianceActivityGroupSelect from './select';

const ComplianceActivityGroupList = (props) => {
  const {
    groups,
    configuration: {
      formName,
      groupName
    },
    callbacks: {
      onChangeActivity: callbackOnChangeActivity
    }
  } = props;

  const [activityGroups, setActivityGroups] = useState(props?.activityGroups || []);

  const addNewActivityGroup = (e) => {
    let activityGroupAttributes = {
      id: "",
      name: "",
      compliance_group_id: "",
      mandatory: false,
      _destroy: false,
    }

    setActivityGroups(prevState => [... prevState, activityGroupAttributes])

    if(_.isFunction(callbackOnChangeActivity)){
      callbackOnChangeActivity({target: {value: activityGroups}}, groupName)
    }
  }

  const onChangeActivityGroups = (groupName, activityGroupIndex, activityGroup) => {
    let _activityGroups = [... activityGroups]
    _activityGroups[activityGroupIndex] = activityGroup

    setActivityGroups(_activityGroups)

    if(_.isFunction(callbackOnChangeActivity)){
      callbackOnChangeActivity({target: {value: _activityGroups}}, groupName)
    }
  }

  const isOptionDisabled = useCallback((option) => {
    return _.some(activityGroups, ag => { return ag?.compliance_group_id == option?.value }) ;
  }, [activityGroups])

  const availableActivityGroups = useMemo(() => {
    return _.filter(activityGroups, (activityGroup) => {
      return !activityGroup._destroy
    })
  }, [activityGroups])

  const renderActivityGroups = () => {
    if(availableActivityGroups?.length > 0){
      return(
        <Row>
          <Col md={12}>
            {
              _.map(availableActivityGroups, (activityGroup, index) => {
                return (
                  <ComplianceActivityGroupSelect
                    key={ `activityGroupSelect-${ index }` }
                    index={ index }
                    groups={ groups }
                    activityGroup={ activityGroup }
                    configuration={{
                      formName: `${ formName }[${ index }]`,
                      groupName: groupName
                    }}
                    callbacks={{
                      onChangeActivityGroups: onChangeActivityGroups
                    }}
                    helpers={{
                      isOptionDisabled: isOptionDisabled
                    }}
                  />
                )
              })
            }
          </Col>
        </Row>
      )
    } else {
      return(
        <Row>
          <Col md={12}>
            <div className="alert alert-primary text-center">
              <i className="fas fa-info-circle mr-2" aria-hidden="true" title="Información"></i>
              <span>{ I18n.t(`messages.without_results`) }</span>
            </div>
          </Col>
        </Row>
      )
    }
  }

  return (
    <Row key={`activityGroupList-${ groupName }`}>
      <Col md={12}>
        { renderActivityGroups() }
      </Col>
      <Col md={12}>
        <Button
            outline
            color="success"
            size="sm"
            onClick={ e => addNewActivityGroup(e) }
          >
            <i className="fas fa-users-group"></i>
            &nbsp;
            { I18n.t("actions.add") }
          </Button>
      </Col>
    </Row>
  )
}

export default ComplianceActivityGroupList;